module.exports = __webpack_public_path__ + "static/media/point8.5461f007.png";